import { Route } from '@angular/router';

import { ComingSoonComponent, mediaGuard, NotFoundComponent, UserAuthGuard } from '@rp/core';
import { ProfileTarget, TargetApp } from '@rp/shared/models';
import { CommonMediaQueries } from '@rp/shared/services';
import { tabsRouteMatcher } from '@rp/utils';

import { ShellComponent } from './shell/shell.component';

export const appRoutes: Route[] = [
  {
    path: 'storybook',
    loadComponent: () => import('@rp/storybook').then(m => m.StorybookComponent),
  },
  {
    path: '',
    component: ShellComponent,
    canActivate: [UserAuthGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'statistic',
      },
      {
        path: 'profile',
        loadComponent: () => import('@rp/pages/profile').then(m => m.ProfileComponent),
        data: {
          header: 'general.advertiserId',
          target: ProfileTarget.Advertiser,
          title: 'headerTitle.profile',
        },
      },
      {
        path: 'finance',
        component: ComingSoonComponent,
      },
      {
        path: 'my-offers',
        component: ComingSoonComponent,
      },
      {
        path: 'instruments',
        component: ComingSoonComponent,
      },
      {
        path: 'infrastructure',
        component: ComingSoonComponent,
      },
      {
        path: 'shop',
        component: ComingSoonComponent,
      },
      {
        path: 'faq',
        loadComponent: () => import('@rp/static-pages').then(m => m.FAQComponent),
      },
      {
        path: 'statistic',
        data: {
          target: TargetApp.Advertiser,
          title: 'statistic.statisticMainReport',
        },
        loadComponent: () => import('@rp/pages/statistic').then(m => m.StatisticGeneralComponent),
      },
      {
        path: 'statistic/:id',
        loadComponent: () => import('@rp/pages/statistic').then(m => m.StatisticDetailsComponent),
        data: {
          target: TargetApp.Advertiser,
        },
      },
      {
        path: '**',
        component: NotFoundComponent,
      },
    ],
  },
];
